<template>
  <div class="user-setting-wrap jzbWrap" style="display: inline-block;min-width:800px" v-loading="loading">
    <el-card>
      <hasBinding @unbinding="unbindingHandler" @gobind="pendingBind" v-if="showHasbingContent" :type="type" :info="getData"></hasBinding>

      <!-- 第一步 -->
      <div v-show="showBindingContentStep">
        <div class="account-number" flex="dir:left cross:center">
          <img :src="userIcon" alt="img" width="38" style="margin-right: 10px">
          <div flex="dir:top">
            <div class="fs-12 c-333" style="margin-bottom:5px">子账户账号</div>
            <div flex="dir:left cross:center">
              <div class="fs-16 c-333 bold">{{jzbAccount}}</div>
              <div class="binding-no" v-if="isPendingStatus != 2">未绑定</div>
              <div class="binding-yes" v-if="isPendingStatus === 2">已绑定</div>
            </div>
          </div>
        </div>
        <el-form :model="firstStepForm" :rules="rules" ref="bindingForm" label-width="120px" inline>
          <div class="box-info-fill">
            <div class="fs-16 c-333 m-b-16 bold" style="padding-left:40px;">银行信息</div>

            <div>
              <el-form-item label="绑定类型" >
                <el-input disabled :value=" type===1 ? '企业':'个人'"></el-input>
              </el-form-item>
            </div>

            <!-- 银行 总行支行 -->
            <div>
              <el-form-item label="银行类型" prop="BankType">
                <el-select
                  v-model.trim="firstStepForm.BankType"
                  placeholder="请选择银行卡类型"
                >
                  <el-option label="本行(平安银行)" :value="1"></el-option>
                  <el-option label="他行(非平安银行)" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="银行名称" prop="bankHead" >
                <el-select
                  clearable
                  filterable
                  v-model.trim="firstStepForm.bankHead"
                  placeholder="请选择银行"
                  @change="checkBankHandler"
                  value-key="eiconBranchNo"
                >
                  <el-option
                    v-for="item in branchNameList"
                    :label="item.branchName"
                    :value="item"
                    :key="item.eiconBranchNo"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="区域" prop="bankRegion">
                <el-cascader
                  clearable
                  v-model="firstStepForm.bankRegion"
                  placeholder="请选择区域"
                  :options="provinceList"
                  :props="regionProps"
                  @change="checkBankRegion"
                >
                </el-cascader>
              </el-form-item>

              <el-form-item label="银行支行" prop="bankChild" >
                <el-select
                  clearable
                  filterable
                  no-data-text="请先选择银行名称和区域"
                  :loading="acctOpenBranchNameListLoading"
                  v-model.trim="firstStepForm.bankChild"
                  value-key="cnapsBranchNo"
                  :placeholder="firstStepForm.bankHead?'请选择支行':'请先选择银行'"
                >
                  <el-option
                    v-for="item in acctOpenBranchNameList"
                    :label="item.branchName"
                    :value="item"
                    :key="item.cnapsBranchNo"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div>
              <el-form-item label="银行卡号" prop="bankCardNum">
                <el-input placeholder="请输入银行卡号" v-model.trim="firstStepForm.bankCardNum"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="Mobile">
                <el-input placeholder="请输入手机号" v-model.trim="firstStepForm.Mobile"></el-input>
                <span style="display:inline-block;padding-left:10px;" class="info">
                  <i class="el-icon-warning"></i>提示:请填写银行卡号绑定的手机号
                </span>
              </el-form-item>
            </div>
          </div>

          <div class="box-info-fill">
            <!-- 商户信息 -->
            <div class="m-b-16">
              <span class="fs-16 c-333 bold" style="padding-left:40px;">商户信息</span>
              <span style="display:inline-block;padding-left:10px;" class="info">
                <i class="el-icon-warning"></i>注意：商户信息一旦提交成功，无法再修改，请仔细核对
              </span>
            </div>
            <!-- 个人绑定 -->
            <div v-if="type === 2">
              <div>
                <!-- 未绑定过的 姓名字段 从后台获取 不能改变 -->
                <el-form-item label="姓名" prop="accountName">
                  <el-input placeholder="请输入姓名" :disabled="hasDefaultVal || nameDisabled" v-model.trim="firstStepForm.accountName"></el-input>
                </el-form-item>

                <el-form-item label="个人证件类型" prop="cardType">
                  <el-select size="mini" filterable clearable v-model.trim="firstStepForm.cardType" :disabled="hasDefaultVal" placeholder="请选择证件类型">
                    <el-option
                      v-for="item in cardTypeList"
                      :key="item.cid"
                      :label="item.name"
                      :value="item.cid"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="个人证件号码" prop="cardNum">
                  <el-input placeholder="请输入个人证件号码" :disabled="hasDefaultVal" v-model.trim="firstStepForm.cardNum"></el-input>
                </el-form-item>
              </div>

              <div>
                <el-form-item label="个体工商户" prop="BusinessFlag">
                  <el-select
                    v-model.trim="firstStepForm.BusinessFlag"
                    placeholder="请选择个体工商户"
                    :disabled="hasDefaultVal"
                  >
                    <el-option label="是" :value="1"></el-option>
                    <!-- 只保留 是的选项 -->
                    <!-- <el-option label="否" :value="2"></el-option> -->
                  </el-select>
                </el-form-item>
              </div>

              <div v-if="firstStepForm.BusinessFlag === 1">
                <el-form-item label="企业名称" prop="companyName">
                  <el-input placeholder="请输入企业名称" :disabled="hasDefaultVal" v-model.trim="firstStepForm.companyName"></el-input>
                </el-form-item>

                <el-form-item label="企业证件类型" prop="companyGlobalType">
                  <el-select size="mini" filterable clearable v-model.trim="firstStepForm.companyGlobalType" :disabled="hasDefaultVal" placeholder="请选择证件类型">
                    <el-option
                      v-for="item in cardTypeList"
                      :key="item.cid"
                      :label="item.name"
                      :value="item.cid"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="企业证件号码" prop="companyGlobalId">
                  <el-input placeholder="请输入企业证件号码" :disabled="hasDefaultVal" v-model.trim="firstStepForm.companyGlobalId"></el-input>
                </el-form-item>
              </div>

              <div v-if="firstStepForm.BusinessFlag === 1">
                <el-form-item :label="firstStepForm.accountName ? '法人' + firstStepForm.accountName : '法人'" prop="repFlag">
                  <el-select
                    v-model.trim="firstStepForm.repFlag"
                    placeholder="是否为法人"
                    :disabled="hasDefaultVal"
                  >
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div v-if="firstStepForm.repFlag === 2 && firstStepForm.BusinessFlag === 1">
                <el-form-item label="法人姓名" prop="reprName">
                  <el-input placeholder="请输入法人姓名" :disabled="hasDefaultVal" v-model.trim="firstStepForm.reprName"></el-input>
                </el-form-item>

                <el-form-item label="法人证件类型" prop="reprGlobalType">
                  <el-select size="mini" filterable clearable v-model.trim="firstStepForm.reprGlobalType" :disabled="hasDefaultVal" placeholder="请选择证件类型">
                    <el-option
                      v-for="item in cardTypeList"
                      :key="item.cid"
                      :label="item.name"
                      :value="item.cid"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="法人证件号码" prop="reprGlobalId">
                  <el-input placeholder="请输入法人证件号码" :disabled="hasDefaultVal" v-model.trim="firstStepForm.reprGlobalId"></el-input>
                </el-form-item>
              </div>
            </div>

            <!-- 企业绑定 -->
            <div v-if="type === 1">
              <div>
                <!-- 未绑定过的 企业名称字段 从后台获取 不能改变 -->
                <el-form-item label="企业名称" prop="accountName">
                  <el-input placeholder="请输入企业名称" :disabled="hasDefaultVal || nameDisabled" v-model.trim="firstStepForm.accountName"></el-input>
                </el-form-item>

                <el-form-item label="统一社会信用代码" prop="cardNum" label-width="145px">
                  <el-input placeholder="请输入统一社会信用代码" :disabled="hasDefaultVal" v-model.trim="firstStepForm.cardNum"></el-input>
                </el-form-item>
              </div>

              <div>
                <el-form-item label="法人姓名" prop="reprName">
                  <el-input placeholder="请输入法人姓名" :disabled="hasDefaultVal" v-model.trim="firstStepForm.reprName"></el-input>
                </el-form-item>

                <el-form-item label="法人证件类型" prop="reprGlobalType">
                  <el-select size="mini" filterable clearable v-model.trim="firstStepForm.reprGlobalType" :disabled="hasDefaultVal" placeholder="请选择证件类型">
                    <el-option
                      v-for="item in cardTypeList"
                      :key="item.cid"
                      :label="item.name"
                      :value="item.cid"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="法人证件号码" prop="reprGlobalId">
                  <el-input placeholder="请输入法人证件号码" :disabled="hasDefaultVal" v-model.trim="firstStepForm.reprGlobalId"></el-input>
                </el-form-item>
              </div>

              <div>
                <el-form-item label="存在经办人" prop="agencyClientFlag">
                  <el-select
                    v-model.trim="firstStepForm.agencyClientFlag"
                    placeholder="是否存在经办人"
                    :disabled="hasDefaultVal"
                  >
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div v-if="firstStepForm.agencyClientFlag === 1">
                <el-form-item label="经办人姓名" prop="agencyClientName">
                  <el-input placeholder="请输入经办人姓名" :disabled="hasDefaultVal" v-model.trim="firstStepForm.agencyClientName"></el-input>
                </el-form-item>

                <el-form-item label="经办人证件类型" prop="agencyClientGlobalType">
                  <el-select size="mini" filterable clearable v-model.trim="firstStepForm.agencyClientGlobalType" :disabled="hasDefaultVal" placeholder="经办人证件类型">
                    <el-option
                      v-for="item in cardTypeList"
                      :key="item.cid"
                      :label="item.name"
                      :value="item.cid"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="经办人证件号" prop="agencyClientGlobalId">
                  <el-input placeholder="请输入经办人证件号" :disabled="hasDefaultVal" v-model.trim="firstStepForm.agencyClientGlobalId"></el-input>
                </el-form-item>

                <el-form-item label="经办人手机号" prop="agencyClientMobile">
                  <el-input placeholder="请输入经办人手机号" :disabled="hasDefaultVal" v-model.trim="firstStepForm.agencyClientMobile"></el-input>
                </el-form-item>

              </div>

            </div>

          </div>

          <div flex="main:center cross:center" style="padding: 20px 0;">
            <el-checkbox v-model="agreement">
              <span style="font-size: 12px;color:#555555;">已阅读并同意</span>
              <a href="https://br.pingan.com/ttest" target="_blank">
                <span style="font-size:12px;color:#FF6224;cursor:pointer;">
                  《平安银行电子商务支付结算服务协议》
                </span>
              </a>
              <a href="https://auth.orangebank.com.cn/#/m/cDealOne?pageConf=1_0_0" target="_blank">
                <span style="font-size:12px;color:#FF6224;cursor:pointer;">
                  《数字口袋协议》
                </span>
              </a>
            </el-checkbox>
          </div>

        </el-form>
      </div>
      <!-- 下一步 -->
      <div style="position: relative;" class="setting-next-card" v-show="nextCardShow">
        <el-form :model="endStepForm" :rules="rules" ref="nextForm" label-width="100px" inline>
          <!-- 图标 -->
          <span
            :class="{'card-type-icon-person':bindType=== '个人','card-type-icon-bus':bindType === '企业'}"
          >{{bindType}}</span>
          <!-- 账户信息-->
          <div>
            <el-form-item label="银行名称">
              <span style="color: #606266;font-size:12px">{{firstStepForm.bankHead | bankname}}</span>
            </el-form-item>
            <el-form-item label="银行卡号">
              <span style="color: #606266;font-size:12px">{{firstStepForm.bankCardNum}}</span>
            </el-form-item>
          </div>
          <!-- 个人 -->
          <template v-if="bindType === '个人' ? true : false">
            <!-- 验证 -->
            <div>
              <el-form-item label="手机号">
                <!-- <span>{{firstStepForm.Mobile}}</span> -->
                <el-input placeholder="请输入手机号" :disabled="true" v-model.trim="firstStepForm.Mobile"></el-input>
                <!-- <el-input placeholder="请输入手机号" v-model.trim="endStepForm.Mobile"></el-input> -->
                <el-button
                  v-if="!showTimer"
                  type="primary"
                  @click="sendMobileCode"
                  size="mini"
                >{{sendMobileCodeText}}</el-button>
                <el-button v-if="showTimer" type="primary" size="mini">{{timer}}s后重新发送</el-button>
              </el-form-item>
            </div>
            <!-- 2021-11-10 开放个人绑定 鉴权金额输入框 -->
            <div>
              <el-form-item label="鉴权金额" prop="amount">
                <el-input placeholder="请输入鉴权金额" v-model.trim="endStepForm.amount">
                  <i slot="prefix" class="iconfont icon-qian" style="font-size:12px;"></i>
                </el-input>
                <span class="info">
                  <i class="el-icon-warning"></i>提示：请查询银行卡转账结果。若成功，请填写绑定银行账户收到的鉴权金额。
                </span>
              </el-form-item>
            </div>
            <!-- 验证码 -->
            <div>
              <el-form-item label="验证码" prop="msgCode">
                <el-input placeholder="请输入验证码" v-model.trim="endStepForm.msgCode"></el-input>
              </el-form-item>
            </div>
          </template>
          <!-- 企业 -->
          <template v-if="bindType === '企业' ? true : false">
            <div>
              <el-form-item label="手机号">
                <!-- <span>{{firstStepForm.Mobile}}</span> -->
                <el-input placeholder="请输入手机号" :disabled="true" v-model.trim="firstStepForm.Mobile"></el-input>
                <el-button
                  v-if="!showTimer"
                  type="primary"
                  @click="sendMobileCode"
                  size="mini"
                >发送验证金额</el-button>
                <el-button v-if="showTimer" type="primary" size="mini">{{timer}}s后重新发送</el-button>
              </el-form-item>
            </div>
            <!-- <span class="info">提示!请查询转账结果，若成功，请在下框填写绑定银行收到的鉴权金额</span> -->
            <div>
              <el-form-item label="鉴权金额" prop="amount">
                <el-input placeholder="请输入鉴权金额" v-model.trim="endStepForm.amount">
                  <i slot="prefix" class="iconfont icon-qian" style="font-size:12px;"></i>
                </el-input>
                <span class="info">
                  <i class="el-icon-warning"></i>提示：请查询银行卡转账结果。若成功，请填写绑定银行账户收到的鉴权金额。
                </span>
              </el-form-item>
            </div>
            <!-- 验证码 -->
            <div>
              <el-form-item label="验证码" prop="msgCode">
                <el-input placeholder="请输入验证码" v-model.trim="endStepForm.msgCode"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="币种">
                <span :style="{'font-size':'12px'}">人民币</span>
              </el-form-item>
            </div>
          </template>
        </el-form>
      </div>
      <div class="submitBtnWrap" v-show="showBindingContentStep">
        <el-button size="mini" @click="nextCardHandler(true,'bindingForm')">下一步</el-button>
      </div>
      <div class="submitBtnWrap" v-show="nextCardShow">
        <el-button size="mini" @click="nextCardHandler(false,'nextForm')">上一步</el-button>
        <el-button size="mini" type="primary" @click="submitForm('nextForm')">提交</el-button>
      </div>
    </el-card>
    <el-dialog
      title="信息认证"
      :modal-append-to-body="false"
      center
      :visible.sync="dialogVisible"
      top="250px"
      width="400px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="jzbWrap exportbtnbox">
        <div class="text-center">平安银行为加强商户安全信息管理，需要重新补充认证信息</div>
        <div style="color: #ff6224;margin-top: 10px;">步骤</div>
        <div style="color: #ff6224;">1.点击“立即认证”前往平安银行页面认证信息</div>
        <div style="color: #ff6224;">2.认证完成后点击“我已认证”</div>
        <div class="add-margin">
          <el-button type="text" class="" @click="initData" >我已认证</el-button>
          <el-button type="primary" class="button-bg-color" @click="navToAuthenticationUrl" >立即认证</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import userIcon from "@/assets/img/user-icon.png";
import hasBinding from './hasBinding'
import { phone, card, bankcard, money, realName } from '@/utils/reg'
import {
  jzbReqAcc,
  jzbReqBankHead,
  jzbReqBankTree,
  jzbReqCardType,
  jzbPersonSendCode,
  jzbPersonBind,
  jzbBusinessSendCode,
  // jzbBusinessBindResult,
  jzbBusinessBind,
  jzbUnbind,
  jzbProvinceList,
  jzbCityList,
  jzbBankAdditionalRecorded,
  jzbSupplementaryUrl
} from '@/models/jzbModel'
export default {
  components: {
    hasBinding,
  },
  filters: {
    bankname (val) {
      let aa = ''
      try {
        aa = val.branchName
        return aa
      } catch (error) {
        return aa
      }
    }
  },
  props: {
    type: {
      type: Number
    }
  },
  data () {
    var checkMobile = (rule, value, callback) => {
      // console.log(rule, 'rule')
      if (value) {
        if (!phone(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入手机号'))
      }
    }
    var checkcard = (rule, value, callback) => {
      // console.log(rule, 'rule')
      if (value) {
        if (!card(value)) {
          callback(new Error('请输入正确的证件号'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入证件号'))
      }
    }
    var checkbankcard = (rule, value, callback) => {
      // console.log(rule, 'rule')
      if (value) {
        if (!bankcard(value)) {
          callback(new Error('请输入正确的银行卡号'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入银行卡号'))
      }
    }
    var checkmoney = (rule, value, callback) => {
      // console.log(rule, 'rule')
      if (value) {
        if (!money(value)) {
          callback(new Error('请输入正确的金额'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入鉴权金额'))
      }
    }

    return {
      loading: false,
      nameDisabled: false,  //  姓名 企业名称禁用
      hasDefaultVal: false, // 后台记录用户数据不可修改
      getData: {}, // 后台返回的数据
      showPendingBind: false, // 等待鉴权状态
      isPendingStatus: null,
      // pendingBindText: '等待鉴权,请点击下一步进行鉴权操作',
      showHasbingContent: false, // 已有绑定界面
      showBindingContentStep: false, // 去往绑定界面
      nextCardShow: false, // 是否显示下一页
      showTimer: false, // 验证码计时
      showBankChoose: true, // 显示转账中
      sendMobileCodeText: '发送验证码',
      timer: 120, // 发送验证码定时
      bindType: '个人',
      jzbAccount: '', // 见证宝子账号
      corpId: '',     //  见证宝对应 公司id
      tranNetMemberCode: '', // 交易网会员代码
      firstStepForm: {
        bindType: 1, // '绑定类型1=个人,2=企业
        bankHead: null, // 总行
        bankChild: null, // 支行
        BankType: 2, // 银行卡类型
        bankCardNum: null, // 银行卡号
        Mobile: null, // 手机号
        cardType: 1, // 证件类型
        cardNum: null, // 证件号
        accountName: null, // 企业开户名
        bankRegion: null, // 区域
        BusinessFlag: null, // 是否个体工商户:1：是 2：否
        companyName: null, // 个体工商户企业名称
        companyGlobalType: null, // 个体工商户证件类型
        companyGlobalId: null, // 个体工商户证件号码
        repFlag: null, // 是否是法人:1-是 2-否
        reprName: null, // 法人姓名
        reprGlobalType: null, // 法人证件类型
        reprGlobalId: null, // 法人证件号码
        agencyClientFlag: null, // 是否存在经办人
        agencyClientName: null, // 经办人姓名
        agencyClientGlobalType: null, // 经办人证件类型
        agencyClientGlobalId: null, // 经办人证件号
        agencyClientMobile: null, // 经办人手机号
      },
      endStepForm: {
        Mobile: null, // 手机号
        msgCode: '', // 验证码
        amount: null // 鉴权金额
      },
      branchNameList: [], // 总行名称
      acctOpenBranchNameList: [], // 支行名称
      acctOpenBranchNameListLoading: false, // 支行可选
      cardTypeList: [], // 证件类型列表
      agreement: false, // 已阅读并同意协议
      rules: {
        Mobile: [{required: true, message: '请输入手机号', trigger: 'change'},{ validator: checkMobile, trigger: 'change' }],
        cardNum: [{required: true, message: '请输入证件号', trigger: 'change'},{ validator: checkcard, trigger: 'change' }],
        bankCardNum: [{required: true, message: '请输入银行卡号', trigger: 'change'},{ validator: checkbankcard, trigger: 'change' }],
        amount: [{required: true, message: '请输入鉴权金额', trigger: 'change'},{ validator: checkmoney, trigger: 'change' }],
        bankHead: [{required: true, message: '请选择银行', trigger: 'change'}],
        bankRegion: [{required: true, message: '请选择区域', trigger: 'change'}],
        bankCity: [{required: true, message: '不能为空', trigger: 'change'}],
        bankChild: [{required: true, message: '请选择支行', trigger: 'change'}],
        accountName: [{required: true, message: '请填写开户行户名', trigger: 'change'}],
        BusinessFlag: [{required: true, message: '不能为空', trigger: 'change'}],
        companyName: [{required: true, message: '请输入企业名称', trigger: 'change'}],
        companyGlobalType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
        companyGlobalId:  [{required: true, message: '请输入企业证件号码', trigger: 'change'}],
        repFlag: [{required: true, message: '是否为法人', trigger: 'change'}],
        reprName: [{required: true, message: '请输入法人姓名', trigger: 'change'}],
        reprGlobalType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
        reprGlobalId: [{required: true, message: '请输入法人证件号码', trigger: 'change'}],
        agencyClientFlag: [{required: true, message: '是否存在经办人', trigger: 'change'}],
        agencyClientName: [{required: true, message: '请输入经办人姓名', trigger: 'change'}],
        agencyClientGlobalType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
        agencyClientGlobalId: [{required: true, message: '请输入经办人证件号', trigger: 'change'}],
        agencyClientMobile: [{required: true, message: '请输入经办人手机号', trigger: 'change'}, { validator: checkMobile, trigger: 'change' }],
        BankType: [
          {
            required: true,
            message: '请选择银行卡类型',
            trigger: 'change'
          }
        ],
        cardType: [
          {
            required: true,
            message: '请选择证件类型',
            trigger: 'change'
          }
        ],
        msgCode: [
          {
            required: true,
            message: '请填写验证码',
            trigger: 'change'
          }
        ]
      },
      dialogVisible: false, // 去认证弹窗
      userIcon: userIcon,
      provinceList: [], // 省地区列表
      cityList: [],     // 市列表
      addressName: [],  // 地址名字
      regionProps: {
        value: 'provinceCode',
        label: 'provinceName',
        lazy: true,
        lazyLoad: this.lazyLoadRegion
      }, // 选择区域配置信息
      authenticationUrl: '', // 去认证地址
    }
  },
  watch: {
    firstStepForm: {
      handler: function (val) {},
      deep: true,
      immediate: true
    }
  },
  methods: {
    initData () {
      this.loading = true
      return jzbReqAcc({
        'shopId': parseInt(localStorage.getItem('shop_id')),
        'objectType': this.type
      }).then(res => {
        if (res.code === 200) {
          let data = res.data[0]
          this.$set(this.$data, 'getData', data)
          console.log(this.getData, '账户信息')
          this.jzbAccount = data.subAcctNo
          this.corpId = data.corpId    // 出参新增公司id
          this.tranNetMemberCode = data.tranNetMemberCode
          if (data.hasOwnProperty('status')) {
            if (data.status === 1) {
              this.hasDefaultVal = false
              this.showPendingBind = true
              this.isPendingStatus = 1

              this.showHasbingContent = false // 已有绑定界面
              this.showBindingContentStep = true // 绑定界面
              this.nextCardShow = false // 是否显示下一页
              try {
                this.firstStepForm.bankHead = {
                  branchCode: data.cnapsBranchNo,
                  branchName: data.bankName,
                  eiconBranchNo: data.eiconBranchNo
                }
                this.firstStepForm.bankChild = {
                  cnapsBranchNo: data.cnapsBranchNo,
                  branchName: data.acctOpenBranchName
                }
                this.firstStepForm.accountName = data.memberAcctName
                this.firstStepForm.BankType = data.bankType
                this.firstStepForm.bankCardNum = data.memberAcctNo
                this.firstStepForm.Mobile = data.mobile
                this.firstStepForm.cardType = data.memberGlobalType
                this.firstStepForm.cardNum = data.memberGlobalNo
                this.firstStepForm.BusinessFlag = parseInt(data.indivBusinessFlag) || null
                this.firstStepForm.companyName= data.companyName // 个体工商户企业名称
                this.firstStepForm.companyGlobalType= data.companyGlobalType // 个体工商户证件类型
                this.firstStepForm.companyGlobalId= data.companyGlobalId // 个体工商户证件号码
                this.firstStepForm.repFlag= data.repFlag // 是否是法人:1-是 2-否
                this.firstStepForm.reprName= data.reprName // 法人姓名
                this.firstStepForm.reprGlobalType= parseInt(data.reprGlobalType) || null // 法人证件类型
                this.firstStepForm.reprGlobalId= data.reprGlobalId // 法人证件号码
                this.firstStepForm.agencyClientFlag= parseInt(data.agencyClientFlag) || null // 是否存在经办人
                this.firstStepForm.agencyClientName= data.agencyClientName // 经办人姓名
                this.firstStepForm.agencyClientGlobalType= parseInt(data.agencyClientGlobalType) || null // 经办人证件类型
                this.firstStepForm.agencyClientGlobalId= data.agencyClientGlobalId // 经办人证件号
                this.firstStepForm.agencyClientMobile= data.agencyClientMobile // 经办人手机号
              } catch (error) {

              }
            } else if (data.status === 2) {
              this.hasDefaultVal = false
              this.$set(this.$data, 'getData', data)
              this.isPendingStatus = 2
              this.firstStepForm.bankCardNum = data.memberAcctNo
              this.firstStepForm.Mobile = data.mobile
              this.showPendingBind = false
              this.showHasbingContent = true // 已有绑定界面
              this.showBindingContentStep = false // 绑定界面
              this.nextCardShow = false // 是否显示下一页
              this.getRecorded()
            } else if (data.status === 0) {
              this.hasDefaultVal = true

              this.firstStepForm.accountName = data.memberAcctName
              this.firstStepForm.BankType = data.bankType
              this.firstStepForm.bankCardNum = data.memberAcctNo
              this.firstStepForm.cardType = data.memberGlobalType
              this.firstStepForm.cardNum = data.memberGlobalNo
              this.firstStepForm.BusinessFlag = parseInt(data.indivBusinessFlag) || null
              this.firstStepForm.companyName= data.companyName // 个体工商户企业名称
              this.firstStepForm.companyGlobalType= data.companyGlobalType // 个体工商户证件类型
              this.firstStepForm.companyGlobalId= data.companyGlobalId // 个体工商户证件号码
              this.firstStepForm.repFlag= data.repFlag // 是否是法人:1-是 2-否
              this.firstStepForm.reprName= data.reprName // 法人姓名
              this.firstStepForm.reprGlobalType= parseInt(data.reprGlobalType) || null // 法人证件类型
              this.firstStepForm.reprGlobalId= data.reprGlobalId // 法人证件号码
              this.firstStepForm.agencyClientFlag= parseInt(data.agencyClientFlag) || null // 是否存在经办人
              this.firstStepForm.agencyClientName= data.agencyClientName // 经办人姓名
              this.firstStepForm.agencyClientGlobalType= parseInt(data.agencyClientGlobalType) || null // 经办人证件类型
              this.firstStepForm.agencyClientGlobalId= data.agencyClientGlobalId // 经办人证件号
              this.firstStepForm.agencyClientMobile= data.agencyClientMobile // 经办人手机号

              this.showPendingBind = false
              this.showHasbingContent = false // 已有绑定界面
              this.showBindingContentStep = true // 绑定界面
              this.nextCardShow = false // 是否显示下一页
            }else if(data.status === -1){
              // 新建账户 未绑定过 （个人维度 姓名 企业维度 企业名称 从返回值 statisticMemberName 字段取）
              this.nameDisabled = true;
              this.firstStepForm.accountName = data.statisticMemberName;
              this.showPendingBind = false
              this.showHasbingContent = false // 已有绑定界面
              this.showBindingContentStep = true // 绑定界面
              this.nextCardShow = false // 是否显示下一页
            }else {
              this.showPendingBind = false
              this.showHasbingContent = false // 已有绑定界面
              this.showBindingContentStep = true // 绑定界面
              this.nextCardShow = false // 是否显示下一页
            }
          } else {
            this.showPendingBind = false
            this.showHasbingContent = false // 已有绑定界面
            this.showBindingContentStep = true // 绑定界面
            this.nextCardShow = false // 是否显示下一页
          }
          //console.log('jzbSuccess', res)
          this.loading = false
        } else {
          this.showPendingBind = false
          this.showHasbingContent = false // 已有绑定界面
          this.showBindingContentStep = true // 绑定界面
          this.nextCardShow = false // 是否显示下一页
          this.loading = false
          // this.$message({
          //   message: res.msg,
          //   type: 'error',
          //   showClose: true
          // })
        }
        return Promise.resolve(res)
      })
        .catch(error => {
          console.log(error)
          this.showPendingBind = false
          this.showHasbingContent = false // 已有绑定界面
          this.showBindingContentStep = true // 绑定界面
          this.nextCardShow = false // 是否显示下一页
        })
    },
    // 完成绑定
    submitForm (formName) {
      // const h = this.$createElement
      this.$refs[formName].validate(valid => {
        if (valid) {
            this.checkPersonBindingResult()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // type=true 下一步 type=false 上一步
    nextCardHandler (type, formName) {
      if (!type) {
        // this.$refs[formName].validate(valid => {})
        if (this.showPendingBind) {
          this.$refs[formName].clearValidate()
          this.nextCardShow = false // 是否显示下一页
          this.showHasbingContent = true // 已有绑定界面
          this.showBindingContentStep = false // 绑定界面
          this.sendMobileCodeText = '发送验证码'
          console.log('待鉴权，up')
        } else {
          this.$refs[formName].clearValidate()
          this.nextCardShow = false // 是否显示下一页
          this.showHasbingContent = false // 已有绑定界面
          this.showBindingContentStep = true // 绑定界面
          this.sendMobileCodeText = '发送验证码'
        }
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if(!this.agreement){
              this.$message({ message: '请阅读并同意平安银行电子商务支付结算服务协议', type: 'warning' })
              return false
            }
            this.showHasbingContent = false // 已有绑定界面
            this.nextCardShow = true // 是否显示下一页
            this.showBindingContentStep = false // 绑定界面
            if (!(this.timer > 0)) {
              this.sendMobileCodeText = '发送验证码'
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    },

    /* 
      解除绑定
      2021 11 03 入参 新加corpId
    */
    unbindingHandler () {
      jzbUnbind({
        'tranNetMemberCode': this.tranNetMemberCode,
        'subAcctNo': this.jzbAccount,
        'memberAcctNo': this.firstStepForm.bankCardNum,
        corpId: this.corpId,
        status: this.isPendingStatus
      })
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: '成功解绑',
              type: 'success'
            })
            Object.assign(this.$data, this.$options.data())
            this.getBankList()
            this.getCardType()
            this.initData().then(res => {
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
    },
    // 未绑定状态 =》去绑定
    bindingHandler () {
      this.showHasbingContent = false // 已有绑定界面
      this.showBindingContentStep = true // 绑定界面
      this.nextCardShow = false // 是否显示下一页
    },

    /* 
      个人 人鉴权发送短信 发送验证码
      2021-11-03 个人鉴权发送短信 /witness/v2.0/acct/bind-union-pay' 接口 入参新增 corpId 字段
    */
    sendMobileCode () {
      let params = this.submitDataFormat()
      jzbPersonSendCode({...params})
        .then(res => {
          if (res.code === 200) {
            if(res.data.txnReturnCode === '000000'){
              this.showTimer = true
              this.$message({
                message: '验证码发送成功',
                type: 'success'
              })
              let time = setInterval(() => {
                this.timer = this.timer - 1
                if (this.timer <= 0) {
                  clearInterval(time)
                  this.showTimer = false
                  this.sendMobileCodeText = '重新发送'
                  this.timer = 120
                }
              }, 1000)
            }else{
              this.$message({
                message: res.data.txnReturnMsg,
                type: 'error'
              })
            }

          } else {
            if (res.msg === '无此有效状态的超网行号') {
              this.$message({
                message: '银行卡号与银行不匹配',
                type: 'error'
              })
            } else
            if (res.msg === '无此有效状态的大小额行号') {
              this.$message({
                message: '银行信息不匹配',
                type: 'error'
              })
            } else
            if (res.msg === '联行号与超网行号不匹配') {
              this.$message({
                message: '总行支行不匹配',
                type: 'error'
              })
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              })
            }
          }
        })
    },
    
    /* 
      个人鉴权 提交
      2021 11 03 个人鉴权 /witness/v2.0/acct/check-code-union 接口 入参新增 corpId 字段
    */
    async checkPersonBindingResult () {
      let obj = {
        // 鉴权金额 入参修改
        // authAmt: this.firstStepForm.bindType === 1 ? 0.01 : this.endStepForm.amount,
        authAmt: this.endStepForm.amount,             // 鉴权金额
        ccy: 'RMB',                                   //  币种
        memberAcctNo: this.firstStepForm.bankCardNum, // 会员的待绑定账户的账号
        orderNo: this.endStepForm.msgCode, // 短信验证码
        subAcctNo: this.jzbAccount, // 见证子账户的账号
        corpId: this.corpId,        //  公司ID
        // 新增入参 2021 11 16
        cityCode: this.firstStepForm.bankRegion && this.firstStepForm.bankRegion.length == 2 ? this.firstStepForm.bankRegion[1] : '',     // 市编码
        cityName: this.addressName && this.addressName.length == 2 ? this.addressName[1] : '',                                            // 市名称
        provinceCode: this.firstStepForm.bankRegion && this.firstStepForm.bankRegion.length == 2 ? this.firstStepForm.bankRegion[0] : '', // 省编码
        provinceName: this.addressName && this.addressName.length == 2 ? this.addressName[0] : '',                                        // 省名称
        acctOpenBranchName: this.firstStepForm.bankChild.branchName,        // 会员的待绑定账户的开户行名称
        bindType: this.type,                                                // 绑定类型，2 - 个人，1 - 企业
        cnapsBranchId: this.firstStepForm.bankChild.cnapsBranchNo,          // 会员的待绑定账户的开户行的联行号
        eiconBankBranchId: this.firstStepForm.bankHead.eiconBranchNo,       // 会员的待绑定账户的开户行的超级网银行号
        headOfficeBankName: this.firstStepForm.bankHead.branchName,         // 银行总行
        memberName: this.firstStepForm.accountName,                         // 见证子账户的户名
      }

      console.log(obj, '入参')

      jzbPersonBind({...obj}).then(res => {
        if (res.code === 200) {
          if(res.data.txnReturnCode === '000000'){
            const h = this.$createElement
            this.$msgbox({
              message: h('p', null, [
                h('span', { class: 'el-icon-success', style: 'color: #67c23a;font-size:20px;font-weight:600;' }, ''),
                h('p', { style: 'font-size:14px;font-weight:600;padding:7px 0' }, '恭喜,绑定成功')
                // h('p', { style: 'color: #ff6224;font-size:20px;font-weight:600;' }, this.cashForm.amount)
              ]),
              showCancelButton: false,
              confirmButtonText: '知道了',
              showClose: false,
              closeOnClickModal: false,
              confirmButtonClass: 'confirm_btn_style',
              center: true
            })
            this.initData()
              .then(() => {
                this.showPendingBind = false
                this.showHasbingContent = true // 已有绑定界面
                this.nextCardShow = false // 是否显示下一页
                this.showBindingContentStep = false // 绑定界面
                this.showTimer = false // 验证码计时
              })
          }else{
            this.$message({
              message: res.data.txnReturnMsg,
              type: 'error'
            })
          }

        } else {
          const h = this.$createElement
          this.$msgbox({
            message: h('p', null, [
              h('span', { class: 'el-icon-error', style: 'color: #ff6224;font-size:20px;font-weight:600;' }, ''),
              h('p', { style: 'font-size:20px;font-weight:600;padding:7px 0' }, '绑定失败'),
              h('p', { style: 'color: #ff6224;font-size:14px;font-weight:600;' }, res.msg)
            ]),
            showCancelButton: false,
            confirmButtonText: '知道了',
            showClose: false,
            closeOnClickModal: false,
            confirmButtonClass: 'confirm_btn_style',
            center: true
          })
          // this.$message({
          //   message: res.msg,
          //   type: 'warning'
          // })
        }
      })
    },
    // 组装公用参数
    submitDataFormat () {
      let params = {
        acctOpenBranchName: this.firstStepForm.bankChild.branchName, //会员的待绑定账户的开户行名称
        agencyClientFlag: this.firstStepForm.agencyClientFlag, // 是否存在经办人
        bankType: this.firstStepForm.BankType, // 会员的待绑定账户的本他行类型Y
        //bindType: this.firstStepForm.bindType, // 绑定类型
        bindType: this.type, // 绑定类型  企业 1 个人 2
        cnapsBranchId: this.firstStepForm.bankChild.cnapsBranchNo, // 支行卡号
        eiconBankBranchId: this.firstStepForm.bankHead.eiconBranchNo, // 超级网银行号
        headOfficeBankName: this.firstStepForm.bankHead.branchName, // 银行总行
        indivBusinessFlag: this.firstStepForm.BusinessFlag, // 是否个体工商户:1：是 2：否
        memberAcctNo: this.firstStepForm.bankCardNum, // 会员的待绑定账户的账号
        memberGlobalId: this.firstStepForm.cardNum, // 会员证件号码Y
        memberGlobalType: this.firstStepForm.bindType === 1 ? this.firstStepForm.cardType : 73, // 会员证件类型
        memberName: this.firstStepForm.accountName, // 见证子账户的户名
        mobile: this.firstStepForm.Mobile, // 手机号',
        subAcctNo: this.jzbAccount, // 见证子账户的账号
        tranNetMemberCode: this.tranNetMemberCode, // 交易网会员代码
        corpId: this.corpId            //  公司ID
      }
      if(this.firstStepForm.BusinessFlag == 1){
        params.companyGlobalId = this.firstStepForm.companyGlobalId; // 公司证件号码=个体工商户必输
        params.companyGlobalType = this.firstStepForm.companyGlobalType; // 公司证件类型
        params.companyName = this.firstStepForm.companyName; // 公司名称
        params.repFlag = this.firstStepForm.repFlag; // 会员名称是否是法人
        params.shopName = localStorage.getItem('username'); // 	店铺名称:个体工商户必输
        params.shopId = parseInt(localStorage.getItem('shop_id')); // 店铺id:个体工商户必输，可与交易网会员代码相同
      }
      if (this.firstStepForm.repFlag == 1 || this.firstStepForm.bindType == 2) {
        params.reprGlobalId = this.firstStepForm.reprGlobalId; // 法人证件号码
        params.reprGlobalType = this.firstStepForm.reprGlobalType; // 法人证件类型=
        params.reprName = this.firstStepForm.reprName; // 法人名称
      }
      if (this.firstStepForm.agencyClientFlag == 1) {
        params.agencyClientGlobalId = this.firstStepForm.agencyClientGlobalId; // 经办人证件号
        params.agencyClientGlobalType = this.firstStepForm.agencyClientGlobalType; // 	经办人证件类型
        params.agencyClientMobile = this.firstStepForm.agencyClientMobile; // 	经办人手机号
        params.agencyClientName = this.firstStepForm.agencyClientName; // 	经办人姓名
      }
      if(this.firstStepForm.bindType == 2){
        params.repFlag = 2; // 会员名称是否是法人
        params.shopName = localStorage.getItem('username'); // 	店铺名称:企业必输
        params.shopId = parseInt(localStorage.getItem('shop_id')); // 店铺id:企业必输，可与交易网会员代码相同
      }
      return params
    },
    // 获取证件类型
    getCardType () {
      jzbReqCardType({}).then(res => {
        if (res.code === 200) {
          this.cardTypeList = res.data
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 获取银行列表
    getBankList () {
      jzbReqBankHead({}).then(res => {
        if (res.code === 200) {
          this.branchNameList = res.data
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 获取区域省
    getProvinceBankList () {
      jzbProvinceList({}).then(res => {
        if (res.code === 200) {
          this.provinceList = res.data
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    },
    // 获取区域市
    lazyLoadRegion(node, resolve){
      const {value, level} = node
      if(level === 1){
        jzbCityList(value).then(res => {
          const nodes = res.data.map(item => {
            const emm = {
              provinceCode: item.cityCode,
              provinceName: item.name,
              leaf: true
            }
            this.cityList.push({
              cityCode: item.cityCode,
              cityName: item.name,
              provinceCode: item.provinceCode,
            })
            return emm
          })
          resolve(nodes)
        }).catch((err) => {
          resolve([])
        })
      }else{
        resolve([])
      }
    },
    // 获取支行列表
    getBankTreeList () {
      if(!this.firstStepForm.bankRegion || !this.firstStepForm.bankHead) return
      this.acctOpenBranchNameListLoading = true
      jzbReqBankTree({
        cityCode: this.firstStepForm.bankRegion && this.firstStepForm.bankRegion.length == 2 ? this.firstStepForm.bankRegion[1] : '',
        eiconBranchNo: this.firstStepForm.bankHead.eiconBranchNo || ''
      })
        .then(res => {
          if (res.code === 200) {
            this.acctOpenBranchNameList = res.data
            this.acctOpenBranchNameListLoading = false
          } else {
            this.acctOpenBranchNameListLoading = false
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.acctOpenBranchNameListLoading = false
        })
    },
    // 选择总行
    checkBankHandler (val) {
      if (val) {
        this.firstStepForm.bankChild = null
        this.acctOpenBranchNameList = []
        this.getBankTreeList()
      } else if (!val) {
        this.firstStepForm.bankChild = null
        this.acctOpenBranchNameList = []
      }
    },
    // 选择区域
    checkBankRegion(val){
      this.addressName = [];
      if (val.length > 0) {
        this.firstStepForm.bankChild = null
        this.acctOpenBranchNameList = []
        this.getBankTreeList()
        if(val.length > 1){
          this.provinceList.map(item => {
            if(item.provinceCode == val[0]){
              this.addressName.push(item.provinceName)
            }
          })
          this.cityList.map(item => {
            if(item.cityCode == val[1]){
              this.addressName.push(item.cityName)
            }
          })
        }
      } else {
        this.firstStepForm.bankChild = null
        this.acctOpenBranchNameList = []
      }
    },
    // 证件名
    cardTypeName (val) {
      let name = ''
      this.cardTypeList.forEach(item => {
        if (item.cid === val) {
          name = item.name
        }
      })
      return name
    },
    // 待鉴权鉴权 直接到下一步
    pendingBind () {
      console.log('待鉴权鉴权', this.firstStepForm)
      // // this.showPendingBind = false
      // this.showHasbingContent = false // 已有绑定界面
      // this.nextCardShow = true // 是否显示下一页
      // this.showBindingContentStep = false // 绑定界面
      // this.showTimer = false // 验证码计时
      if (this.firstStepForm.bindType === 1) {
        this.bindType = '个人'
        // this.showPendingBind = false
        this.showHasbingContent = false // 已有绑定界面
        this.nextCardShow = true // 是否显示下一页
        this.showBindingContentStep = false // 绑定界面
        this.showTimer = false // 验证码计时
      }
      if (this.firstStepForm.bindType === 2) {
        this.bindType = '企业'
        // this.showPendingBind = false
        this.showHasbingContent = false // 已有绑定界面
        this.nextCardShow = true // 是否显示下一页
        this.showBindingContentStep = false // 绑定界面
        this.showTimer = false // 验证码计时
      }
    },
    getRecorded(){
      jzbBankAdditionalRecorded(this.jzbAccount).then((res) => {
        if(res.data.txnReturnCode === '000000'){
          this.dialogVisible = false
        }else{
          console.log(this.firstStepForm)
          jzbSupplementaryUrl({subAcctNo: this.jzbAccount,mobile: this.firstStepForm.Mobile}).then((response) => {
            this.authenticationUrl = response.data
            this.dialogVisible = true
          })
        }
      })
    },
    navToAuthenticationUrl(){
      window.open(this.authenticationUrl,'','width=500,height=800');
    }
  },
  async created () {
    await this.getBankList()
    await this.getProvinceBankList()
    await this.getCardType()
    await this.initData().then((res) => {
      console.log('初始化数据')
    })
    if(this.type === 1){
      this.bindType = '企业'
      this.firstStepForm.bindType = 2
    }else{
      this.bindType = '个人'
      this.firstStepForm.bindType = 1
    }
  }
}
</script>
<style lang="scss" scoped>
.user-setting-wrap {
  min-height: 400px;
  .el-form {
    .el-form-item {
      margin-bottom: 14px;
    }
  }

  .setting-next-card {
    position: relative;

    .card-type-icon-person {
      // background-color: rgba(230, 188, 140, 0.39);
      background: linear-gradient(
        to right,
        rgba(220, 146, 6, 0.39),
        rgb(180, 142, 96)
      );
      display: inline-block;
      border-radius: 0 5px 5px 0;
      padding: 5px;
      position: absolute;
      top: 7px;
      left: 0;
      width: 25px;
      text-align: center;
      font-size: 8px;
      color: #fff;
    }

    .card-type-icon-bus {
      background: -webkit-gradient(
        linear,
        left top,
        right top,
        from(rgba(160, 169, 185, 0.51)),
        to(#0a4ef2)
      );
      // background: linear-gradient(to right, rgba(160, 169, 185, 0.51), #0a4ef2);
      display: inline-block;
      border-radius: 0 5px 5px 0;
      padding: 5px;
      position: absolute;
      top: 7px;
      left: 0;
      width: 25px;
      text-align: center;
      font-size: 8px;
      color: #fff;
    }
  }

  .info {
    display: inline-block;
    padding-left: 10px;
    font-size: 10px;
    color: #FF6224;
    // padding-left: 100px;
  }

  .transferBox {
    position: absolute;
    top: 40%;
    left: 40%;
    background: #0b0b0b63;
    color: #fff;
    padding: 15px;
    border-radius: 5px;
  }
  .submitBtnWrap {
    text-align: center;
    margin-top: 20px;
  }
  .fs-12{
    font-size: 12px;
  }
  .fs-15{
    font-size: 15px;
  }
  .fs-16{
    font-size: 16px;
  }
  .fs-20{
    font-size: 20px;
  }
  .c-333{
    color: #333;
  }
  .bold{
    font-weight: bold;
  }
  .m-b-16{
    margin-bottom: 16px;
  }
  .account-number{
    margin-bottom: 20px;
    .binding-no{
      width: 48px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      background: #EFEFEF;
      border-radius: 3px;
      color: #999999;
      font-size: 12px;
      margin-left: 10px;
    }
    .binding-yes{
      width: 48px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      background: #E9FAEE;
      border-radius: 3px;
      color: #2DBA59;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .box-info-fill{
    background: #FAFAFA;
    border-radius: 3px;
    margin-bottom: 20px;
    padding-top: 20px;
  }
}
.exportbtnbox {
  text-align: left;
  .el-button {
    padding: 10px;
    background: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
    position: relative;
    width: 100px;
    .inputfile {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      height: 100%;
      width: 100%;
    }
  }
  .el-button:hover {
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
  .add-margin{
    margin-top: 20px;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/userBinding.vue